module.exports = __webpack_public_path__ + "static/media/social-icon-x-purple.3b0974e7.svg";